// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-head.pla .price-extra-info-container{justify-content:flex-start}.product-head.pla .price-extra-info-container .extra-info{margin-top:0px;margin-bottom:8px;margin-left:1px;text-align:left}@media (max-width: 970px){.product-head.pla .price-extra-info-container .extra-info{margin-left:20px}}.product-head.pla .price-extra-info-container .extra-info .extra-info-text:hover{color:var(--grey-light)}.product-head.pla .price-extra-info-container .extra-info .af-about-small{margin-right:12px}.product-head.pla .price-extra-info-container .extra-info .affirm-message{display:flex}.product-head.pla .price-extra-info-container .extra-info .affirm-message .affirm-modal-trigger{margin-left:var(--space-2)}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
